import { useEffect } from "react";

import Footer from "../components/Footer";
import TechnologyHero from "../components/technology/TechnologyHero";
import TechnologyNavigation from "../components/technology/TechnologyNavigation";
import TechnologyIntro from "../components/technology/TechnologyIntro";
import {
  WebApplicationSection,
  LandingPageSection,
  DigitalMarketingServiceSection,
  AppDevelopmentSection,
  AnimatedWebsiteSection,
  VideoEditingSection,
} from "../components/technology/TechnologyServices";
import TechnologyProducts from "../components/technology/TechnologyProducts";
import TechnologyWhy from "../components/technology/TechnologyWhy";
import TechnologyCTA from "../components/technology/TechnologyCTA";

export default function Technology() {
  useEffect(() => {
    document.title =
      "Software Development & Digital Marketing Services in Karaikudi | WE3X";

    let meta = document.querySelector('meta[name="description"]');

    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }

    meta.content =
      "WE3X Technologies provides web application development, landing pages, mobile app development, animated websites, digital marketing and video editing services in Karaikudi.";
  }, []);

  return (
    <main className="overflow-hidden bg-[#f6f6f6] text-[#111111]">
      <TechnologyHero />
      <TechnologyNavigation />
      <TechnologyIntro />

      <WebApplicationSection />
      <LandingPageSection />
      <DigitalMarketingServiceSection />
      <AppDevelopmentSection />
      <AnimatedWebsiteSection />
      <VideoEditingSection />

      <TechnologyProducts />
      <TechnologyWhy />
      <TechnologyCTA />
      <Footer />
    </main>
  );
}
